<template>
  <div class="card_template_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveModule">保存</el-button>
    </div>
    <div class="card_template_add_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="card_template_add_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="卡名称" prop="name">
            <el-input v-model="formData.name" :minlength="2" :maxlength="16" placeholder="请输入卡名称"></el-input>
          </el-form-item> 
          <el-form-item label="卡积分" prop="point">
            <el-input-number v-model="formData.point" controls-position="right" :min="1" :max="10000"></el-input-number>
          </el-form-item>
          <el-form-item label="学校" prop="fromSchId">
                  <el-autocomplete class="inline-input" style="width:100%" v-model="formData.fromSchName"  :fetch-suggestions="querySearch" placeholder="请输入学校名称并选择"  :trigger-on-focus="false"  @select="handleSelect" ></el-autocomplete>
         </el-form-item>
           <el-form-item label="分类" prop="groupName">
            <el-select v-model="formData.groupName" placeholder="请选择分类" >
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡排版" >
             <el-radio v-model="formData.templateAxis" :label="2">竖版</el-radio>
             <el-radio v-model="formData.templateAxis" :label="1">横版</el-radio>
          </el-form-item>
          <el-form-item label="卡封面（正面）" prop="frontLogo">
            <div :class="{'hengshu' : formData.templateAxis==1}">
               <uploader :picOperationRule="''" pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="frontLogo" :openDelete="true"></uploader>
            </div>
          </el-form-item>
          <el-form-item label="卡封面（背面）" prop="backLogo">
            <div :class="{'hengshu' : formData.templateAxis==1}">
               <uploader :picOperationRule="''" pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="backLogo" :openDelete="true"></uploader>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import Uploader from "@/components/Uploader/WebUploader";
  import {findDicsByCode} from '@/api/common/common';
  import {addIntegralCardTemplate, editIntegralCardTemplate, getIntegralCardTemplateInfoById,querySchoolListByName} from '@/api/integralBank';

  export default {
    name: "cardTemplateAdd",
    components: {Uploader},
    data() {
      const validateLogo = (rule, value, callback) => {
        if (!this.frontLogo.length || !this.backLogo.length) {
          callback(new Error('请上传封面'));
        } else {
          callback();
        }
      };
      return {
        templateId: this.$route.query.templateId,
        formData: {
          frontUrl: '',
          backUrl: '',
          name: '',
          point: 10,
          templateAxis:2,
          groupName:'',
          fromSchId:'',
          fromSchName:''
        },
        rules: {
          frontLogo: [
            {required: true, validator: validateLogo}
          ],
          backLogo: [
            {required: true, validator: validateLogo}
          ],
          point: [
            {required: true}
          ],
          name: [
            { required: true, trigger: 'blur', message: '请输入卡名称' },
            { min: 2, max: 16, message: "输入长度在2到16个字符", trigger: "change" },            
          ],
          groupName:[
            { required: true, trigger: 'change', message: '请选择分类' },           
          ],
          fromSchId:[
            { required: true, trigger: 'change', message: '请选择学校' },           
          ],
        },
        frontLogo: [],
        backLogo: [],
        typeList:[]
      }
    },
    mixins: [windowResize],
    created() {
       findDicsByCode({dicCode: 'integralCardTemplateGroup'}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.typeList = data.data;
          }
        });
      if (this.templateId) this.getIntegralCardTemplateInfoById();
    },
    methods: {
       querySearch(name, cb) {
       querySchoolListByName({name:name}).then(res => res.data).then(data => {
                            if(data.result) {
                              let results=[]
                              let mydata=data.data;
                              for(let i=0;i<mydata.length;i++){
                                results.push({
                                  value:mydata[i].name+"_"+mydata[i].id,
                                  id:mydata[i].id
                                })
                              }
                              cb(results);
                            
                           }
        })
      },
      handleSelect(item) {
        this.formData.fromSchId=item.id
      },
      goBack() {
        this.$router.go(-1);
      },
      getIntegralCardTemplateInfoById() {
        getIntegralCardTemplateInfoById({id: this.templateId}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.formData = {
              frontUrl: data.data.frontUrl,
              backUrl: data.data.backUrl,
              name: data.data.name,
              point: data.data.point,
              templateAxis: data.data.templateAxis,
              groupName:data.data.groupName,
              fromSchName:data.data.fromSchName,
              fromSchId:data.data.fromSchId||'',
            };
            this.frontLogo = [{
              fileUrl: data.data.frontUrl
            }];
            this.backLogo = [{
              fileUrl: data.data.backUrl
            }]
          }
        });
      },
      saveModule() {
        this.$refs.form.validate(isValid => {
          if(isValid) {
            this.formData.frontUrl = this.frontLogo[0].fileUrl;
            this.formData.backUrl = this.backLogo[0].fileUrl;
            console.log(this.formData);
            new Promise(resolve => {
              if(this.templateId) {
                this.formData.id = this.templateId;
                editIntegralCardTemplate(this.formData).then(res => res.data).then(resolve)
              } else {
                addIntegralCardTemplate(this.formData).then(res => res.data).then(resolve)
              }
            }).then(data => {
              if (data.code === 200 && data.result) {
                this.$message.success(`${this.templateId ? '编辑' : '新增'}成功`);
                window.setTimeout(() => {
                  this.goBack();
                }, 500);
              } else {
                this.$message.success(data.msg);
              }
            })
          }
        })
      }
    }
  }
</script>

<style>
  .card_template_add_wrap .upload-block-container .upload-file-item{
    width: 187px;
    height: 273px;
  }
  .card_template_add_wrap .upload-block-container .upload-file-item img{
    width: 182px;
    height: 273px;
  }
   .card_template_add_wrap .hengshu .upload-block-container .upload-file-item{
    height: 187px;
    width: 273px;
  }
  .card_template_add_wrap .hengshu .upload-block-container .upload-file-item img{
    height: 182px;
    width: 273px;
  }
</style>
<style lang="scss" scoped>
  @import './../../styles/mixin';

  .card_template_add_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .card_template_add_box{
      @include scrollBar;

      .card_template_add_content{
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardTemplateAdd.vue